// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1m33N","rootNoMargin":"styles_rootNoMargin__1FMow"};